import { ApiEndpoints } from "@shared/api/api-endpoints";
import {
  bxApiClient,
  receiptApiClient,
} from "@shared/api/clients/apiClientFactory";
import { QueryStringParameters } from "@shared/api/url-builder";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const saveBillTemplate = async (payload) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration`
  );
  const response = await receiptApiClient.post(url, payload);
  return response.data?.result;
};

export const updateBillTemplate = async (id: string, payload) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration/${id}`
  );
  const response = await receiptApiClient.put(url, payload);
  return response.data?.result;
};
export const getTemplate = async (templateId?: string | number) => {
  const basePath = "base-template-configuration";
  const path = templateId ? `${basePath}/${templateId}` : basePath;

  const url = ApiEndpoints.createUrlWithQueryParameters("receipt", path);
  const response = await bxApiClient.get(url);
  return response.data;
};

export const getTemplateSummary = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `template-summary`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
    }
  );
  const response = await bxApiClient.get(url);
  return response.data;
};

export const getTemplateList = async (
  isActive?: string,
  searchData?: string
): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
      if (isActive) {
        qs.push("is_active", isActive);
      }
      if (searchData) {
        qs.push("search", searchData);
      }
    }
  );
  const response = await bxApiClient.get(url);
  return response.data;
};

export const cloneBilltemplate = async (id: string | number) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `clone-template-configuration/${id}`
  );
  const response = await bxApiClient.put(url);
  return response.data?.result;
};

export const changeTemplateStatus = async (
  id: string | number,
  isActive: boolean
) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration/${id}`
  );
  const payload = {
    is_active: isActive,
  };
  const response = await bxApiClient.put(url, payload);
  return response.data?.result;
};

export const deleteTemplate = async (id: string | number) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration/${id}`
  );
  const response = await bxApiClient.delete(url);
  return response.data?.result;
};

export const getTemplateOptions = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `fetch-base-templates`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
    }
  );
  const response = await bxApiClient.get(url);
  return response.data.result;
};
